<template>
	<div>
        <div v-if="err"></div>
        <h4 style="color: red;margin-top: 50px;text-align: center;">{{err}}</h4>
        <div style="text-align: center;">
            <el-button type="primary" @click="$router.push('/')" style="margin: auto;">返回首页</el-button>
        </div>
	</div>
</template>
<script>
export default {
	data () {
		return {
			loading:{},
            err:'',
		}
	},
	mounted(){
		this.loading = this.$loading({
          	lock: true,
          	text: 'Email activation...',
          	spinner: 'el-icon-loading',
          	background: 'rgba(0, 0, 0, 0.7)'
        });
        this.$axios({
            method: 'get',
            url:'/api/email/verify/'+this.$route.params.id,
            params:{
            	expires:this.$route.params.expires,
            	signature:this.$route.params.signature
            }
        }).then(res => {
            console.log(res);
            this.$localStorage.setItem('token',res.access_token);
            this.$localStorage.setItem('token_type',res.token_type);
            this.$message({
            	message:this.$t('btnText.activaSuccess'),
            	type: 'success',
        		duration:1800,
        		offset:200
            });
            var that=this;
            setTimeout(function(){
                that.loading.close();
                that.$router.push('/');
            },1000)
        }).catch(error=>{
            this.loading.close();
            if(error.response){
                if(error.response.data.message){
                    this.err=error.response.data.message;
                }
            }
        });
	},
	methods:{
		
	}
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/common/VerifyEmail.vue